export const environment = {
  production: true,
  domain: 'dsp.mataloka.com',
  apiUrl: 'https://amh-api-gateway-fe-1r72n2y7.an.gateway.dev/api/v1',
  API_KEY: 'AIzaSyDYHssjk3UgLxTfgtGUosGp60oMktKrouU',
  appName: 'MataLoka - DSP',
  geoapifyApiKey: '2825cff5a6fc4254838f14e73c1a9ecb',
  googleClientId: '137564986543-7ob701dlia3cdhc4o5eq0s9n989vbpav.apps.googleusercontent.com',
  userType: 'Advertisers' as const,
  features: {
    auth: false,
    dsp: true,
    ssp: false
  },
  allowedRoutes: ['/main/campaign', '/main/welcome'],
  restrictedRoutes: ['/main/inventory'],
  loginDomain: 'https://login.mataloka.com'
};
